module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Home/Armchair-0679793c881f9b59cac95f274daa20b9.svg";